export default __webpack_public_path__ + "static/media/blob-haikei (2).eaa5fe67.png";